<div class="card mb-3 text" *ngIf="widget"  [ngClass]="getStyle(point)" [class.highlighted]="highlighted"
  (mouseenter)="hover()" (mouseleave)="unhover()">  

  <div class="card-body" *ngIf="!widget.hidden">
  
    <div class="d-flex fw-bold small text-truncate text-uppercase">
        <span class="flex-grow-1">{{widget.name}}</span>
    </div>
    
    
    <div class="row align-items-center mb-2">
      <div class="col-7">
          <h3 class="mb-0" *ngIf="point == null">...</h3>
          <h3 class="mb-0" *ngIf="point != null && point.value != null">{{point.value | number}} <small *ngIf="w">{{w.units}}</small></h3>
      </div>
      <div class="col-5">
        <ngx-trend [data]="values" padding="0" autoDraw="true" strokeWidth="4"
          autoDrawDuration="1000"  [gradient]="['#3cd2a5']"
          autoDrawEasing="ease-in"></ngx-trend>
      </div>
    </div>
  
  
    <div class="small text text-opacity-50 text-truncate" *ngIf="this.alternative">
      <i class="fa fa-fw me-1" [ngClass]="getIcon()"></i> {{widget.alternative}} : {{this.alternative.value}}
    </div>
    <div class="small text text-opacity-50 text-truncate" *ngIf="this.alternative == null">
      <i class="fa fa-square fa-fw me-1"></i> ...
    </div>
    <div class="small text text-opacity-50 text-truncate" *ngIf="point != null && point.value != null">
      <i class="fa fa-clock-o fa-fw me-"></i> {{point.timeStamp | relativeDate}}
    </div>
  
  </div>
  
  <div class="card-body" *ngIf="widget.hidden">
    <div class="d-flex fw-bold small text-truncate text-uppercase">
      <span class="flex-grow-1">{{widget.name}}</span>
    </div>
    <div class="no-data-container">
      <div class="no-data-message">{{widget.noDataMessage}}</div>
    </div>  

  </div>
  
  
</div>